import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import {
  PlayArrow as StartIcon,
  Pause as PauseIcon,
  Stop as StopIcon,
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

/**
 * ExperimentStatusActions Component
 *
 * Displays action buttons (Start, Pause, Stop) based on experiment status.
 *
 * @param {Object} props
 * @param {Object} props.experiment - Experiment object
 * @param {Function} props.onStatusChange - Callback when status changes
 */
function ExperimentStatusActions({ experiment, onStatusChange }) {
  const theme = useTheme();

  if (!experiment) return null;

  const actions = [];

  switch (experiment.status) {
    case 'draft':
      actions.push(
        <Tooltip key="start" title="Start Experiment">
          <IconButton
            onClick={() => onStatusChange(experiment.id, 'start')}
            sx={{
              color: theme.palette.success.main,
              '&:hover': {
                backgroundColor: theme.palette.success.light,
                color: theme.palette.success.dark,
              },
            }}
          >
            <StartIcon />
          </IconButton>
        </Tooltip>
      );
      break;
    case 'active':
      actions.push(
        <Tooltip key="pause" title="Pause Experiment">
          <IconButton
            onClick={() => onStatusChange(experiment.id, 'pause')}
            sx={{
              color: theme.palette.warning.main,
              '&:hover': {
                backgroundColor: theme.palette.warning.light,
                color: theme.palette.warning.dark,
              },
            }}
          >
            <PauseIcon />
          </IconButton>
        </Tooltip>
      );
      actions.push(
        <Tooltip key="stop" title="Stop Experiment">
          <IconButton
            onClick={() => onStatusChange(experiment.id, 'stop')}
            sx={{
              color: theme.palette.error.main,
              '&:hover': {
                backgroundColor: theme.palette.error.light,
                color: theme.palette.error.dark,
              },
            }}
          >
            <StopIcon />
          </IconButton>
        </Tooltip>
      );
      break;
    case 'paused':
      actions.push(
        <Tooltip key="start" title="Resume Experiment">
          <IconButton
            onClick={() => onStatusChange(experiment.id, 'start')}
            sx={{
              color: theme.palette.success.main,
              '&:hover': {
                backgroundColor: theme.palette.success.light,
                color: theme.palette.success.dark,
              },
            }}
          >
            <StartIcon />
          </IconButton>
        </Tooltip>
      );
      actions.push(
        <Tooltip key="stop" title="Stop Experiment">
          <IconButton
            onClick={() => onStatusChange(experiment.id, 'stop')}
            sx={{
              color: theme.palette.error.main,
              '&:hover': {
                backgroundColor: theme.palette.error.light,
                color: theme.palette.error.dark,
              },
            }}
          >
            <StopIcon />
          </IconButton>
        </Tooltip>
      );
      break;
    default:
      break;
  }

  return <>{actions}</>;
}

export default ExperimentStatusActions;
